import { render, staticRenderFns } from "./RueckrufBitte.vue?vue&type=template&id=1ba24aa6"
import script from "./RueckrufBitte.vue?vue&type=script&lang=js"
export * from "./RueckrufBitte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports